import styled, { css } from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import Media from 'builder/styles/media'

export const Container = styled.div<{ isStepByStepFlow?: boolean }>`
  ${({ isStepByStepFlow }) => {
    return Media.Phone`
       padding: ${() => (isStepByStepFlow ? '20px' : 'unset')};
      `
  }}
`

export const Header = styled.div<{ isStepByStepFlow?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: ${props => (props.isStepByStepFlow ? 'unset' : '8px')};
  padding: ${props => (props.isStepByStepFlow ? '20px 0' : 'unset')};
`

export const Title = styled.p`
  ${Typography.Subhead};
  ${FontWeights.DemiBold};
`

export const Description = styled.p`
  ${Typography.Caption};
  ${FontWeights.Regular};
  color: ${Colors.Neutral50};
`

export const List = styled.div`
  position: relative;
  left: -4px;
  display: flex;
  flex-flow: row wrap;
`

export const Item = styled.div<{ type: string; disabled?: boolean }>(props => {
  const backgroundImage = require(`images/builder/resume-editor/section-${props.type}${
    props.disabled ? '-gray' : ''
  }.svg`)

  return css`
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    margin-bottom: 12px;
    user-select: none;
    width: calc(50% - 32px);
    flex: 0 0 calc(50% - 32px);
    margin-right: 32px;
    cursor: ${props.disabled ? 'default' : 'pointer'};
    color: ${props.disabled ? Colors.Neutral50 : Colors.Neutral90};

    &:hover {
      color: ${props.disabled ? Colors.Neutral50 : Colors.Blue50};
    }

    &:nth-child(2n) {
      margin-right: 0;
    }

    ${Media.Phone`
      width: 100%;
      flex: 0 0 100%;
      margin-right: 0;
    `};

    &:before {
      content: '';
      margin-right: 8px;
      display: block;
      width: 40px;
      height: 40px;
      background-image: url(${backgroundImage});
    }
  `
})
